import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"
import "./App.css"
import { pageRoute, protectedRoutes } from "./components/routes"
import Container from "./components/Container"
import ProtectedRoute from "./common/services/protectedRoute"
import ScrollToTop from "./components/shared-components/ScrollToTop"
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';


const RenderRoute = ({ data, isProtected }) => {
  const Element = data.element
  const content = data.layout ? (
    <Container>
      <Element />
    </Container>
  ) : (
    <Element />
  )

  return isProtected ? <ProtectedRoute>{content}</ProtectedRoute> : content
}

function App() {

  useEffect(() => {
    //let Tawk_API = window.Tawk_API || {};
  //   const s1 = document.createElement("script");

  //   s1.async = false;
  //   s1.src = `https://embed.tawk.to/${process.env.REACT_TAWK_API_KEY}/default`;
  //   s1.charset = "UTF-8";
  //   s1.setAttribute("crossorigin", "*");

  //   const s0 = document.getElementsByTagName("script")[0];
  //   if (s0.parentNode) {
  //     s0.parentNode.insertBefore(s1, s0);
  //   }

  //   s1.onload = () => {
  //  //   Tawk_API = window.Tawk_API;
  //   };
  }, []);


  const allRoutes = [
    ...pageRoute.map((route) => ({ ...route, isProtected: false })),
    ...protectedRoutes.map((route) => ({ ...route, isProtected: true })),
  ]

  return (
    <BrowserRouter>
      <ScrollToTop />
      <TawkMessengerReact
        propertyId="6800c914e604cc190f8721ca"
        widgetId="default"
      />
      <Routes>
        {allRoutes.map((data, i) => (
          <Route
            key={i}
            path={data.path}
            element={<RenderRoute data={data} isProtected={data.isProtected} />}
          />
        ))}
      </Routes>
        <TawkMessengerReact
                propertyId="6800c914e604cc190f8721ca"
                widgetId="1ip1h2umk"
         />
    </BrowserRouter>
  )
}

export default App
